/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountBillingSummaryResponse {
    getFixupPrototypeFunction() { return MasterAccountBillingSummaryResponse.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountBillingSummaryResponse>): MasterAccountBillingSummaryResponse {
        let obj = Object.assign(new MasterAccountBillingSummaryResponse(), model);
        MasterAccountBillingSummaryResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountBillingSummaryResponse>): MasterAccountBillingSummaryResponse {
        if (!model) return null;
        return MasterAccountBillingSummaryResponse.newInstance(<MasterAccountBillingSummaryResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountBillingSummaryResponse) {
        if (!obj) return;

        models.MasterAccountBillingSummaryResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountBillingSummaryResponse): boolean {
        Object.setPrototypeOf(obj, MasterAccountBillingSummaryResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.current_balance === undefined) {
            this.current_balance = 0;
        }
        if (this.total_spend === undefined) {
            this.total_spend = 0;
        }
    }

    /**
     * Current balance for the master account.
     */
    current_balance: number;

    /**
     * Total spend for the master account.
     */
    total_spend: number;

}
